import {Button, Input, Textarea,} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useContext, useEffect, useState} from "react";
import SelectInput from "../../system/select";
import "../../../style/datePicker.css"
import {updateAgentRequestExpertInfo} from "../../../services/agent/agent_request"
import {getDegrees} from "../../../services/degree/degree"
import {getStageDegrees} from "../../../services/stage_degree/stage_degree"
import {getFieldBranches} from "../../../services/branch/branch";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import Validator from "../../../helper/validator/Validator";
import {checkAll} from "../../../helper/validator/Check";
import {AgentRequestContext} from "../../../context/agent_context";
import {toast} from "react-toastify";
import {
  agentRequestFieldClass,
  AgentRequestFieldLabel,
  agentRequestInputProps,
  agentRequestPrimaryButtonClass,
  agentRequestSecondaryButtonClass,
} from "./ui";

export function AgentRequestExpertInfo() {

  const {
    agentRequest,
    setAgentRequest,
    handleNext,
    handlePrev,
    isFirstStep,
    isLastStep,
    allowedStep,
    setAllowedStep,
  } = useContext(AgentRequestContext)

  const [degreeId, setDegreeId] = useState("")
  const [stageDegreeId, setStageDegreeId] = useState("")

  const [branchIds, setBranchIds] = useState([])

  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    setDegreeId(agentRequest?.degree_id ?? null);
    setStageDegreeId(agentRequest?.stage_degree_id ?? null);
    const bids = (agentRequest && agentRequest.branch_ids)
      ? [...new Set(agentRequest.branch_ids.split(',').map(Number))]
      : [];
    setBranchIds(bids);
  }, [])

  useEffect(() => {
    setAgentRequest((prev) => ({
      ...prev,
      degree_id: degreeId,
    }));
  }, [degreeId]);

  useEffect(() => {
    setAgentRequest((prev) => ({
      ...prev,
      stage_degree_id: stageDegreeId,
    }));
  }, [stageDegreeId]);

  const save = async () => {
    const branches = branchIds.map(bid => ({
      agent_id: agentRequest.id,
      branch_id: bid,
    }));

    const data = {
      agent_request: {
        id: agentRequest.id,
        degree_id: parseInt(agentRequest.degree_id),
        stage_degree_id: parseInt(agentRequest.stage_degree_id),
        experience: parseInt(agentRequest.experience),
        speciality: agentRequest.speciality,
        about_me: agentRequest.about_me,
      },
      request_branch_list: branches
    };
    setIsChecked(true)
    const res = checkAll();
    if (!res) {
      toast.error("مقادیر الزامی را بر اساس راهنما تکمیل کنید")
      return
    }
    let result;

    result = await updateAgentRequestExpertInfo(data);

    if (result.status === 200) {
      if (allowedStep === 2) {
        setAllowedStep(3)
      }
      handleNext(3);
    }
  };

  return (
    <ValidatorProvider>
      <>
        <div className="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-2 xxl:grid-cols-3">

          <div className={agentRequestFieldClass}>
            <SelectInput
              stackedLabel
              label={Dict("degree")}
              defaultValue={degreeId}
              autoLoadService={getDegrees}
              onChange={setDegreeId}
            />
            <Validator isChecked={isChecked} state={degreeId} rules="required"/>
          </div>

          <div className={agentRequestFieldClass}>
            <SelectInput
              stackedLabel
              label={Dict("stage_degree")}
              defaultValue={stageDegreeId}
              autoLoadService={getStageDegrees}
              onChange={setStageDegreeId}
            />
            <Validator isChecked={isChecked} state={stageDegreeId} rules="required"/>
          </div>

          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel htmlFor="agent-experience">{Dict('experience')}</AgentRequestFieldLabel>
            <Input {...agentRequestInputProps}
                   id="agent-experience"
                   value={agentRequest.experience}
                   placeholder={Dict('experience')}
                   onChange={(e) => {
                     setAgentRequest((prev) => ({
                       ...prev,
                       experience: e.target.value,
                     }));
                   }}
            />
            <Validator isChecked={isChecked} state={agentRequest.experience} rules="num"/>
            <Validator isChecked={isChecked} state={agentRequest.experience} rules="required"/>
          </div>

          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel htmlFor="agent-speciality">{Dict('speciality')}</AgentRequestFieldLabel>
            <Input {...agentRequestInputProps}
                   id="agent-speciality"
                   value={agentRequest.speciality}
                   placeholder={Dict('speciality')}
                   onChange={(e) => {
                     setAgentRequest((prev) => ({
                       ...prev,
                       speciality: e.target.value,
                     }));
                   }}
            />
            <Validator isChecked={isChecked} state={agentRequest.speciality} rules="required"/>
            <Validator isChecked={isChecked} state={agentRequest.speciality} rules="alphanumeric"/>
          </div>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-5">

          <div className={agentRequestFieldClass}>
            <SelectInput
              stackedLabel
              label={Dict("branch")}
              defaultValue={branchIds}
              multiselect={true}
              autoLoadService={getFieldBranches}
              autoLoadRender={({field_title, title}) => {
                return field_title + " - " + title
              }}
              onChange={setBranchIds}
            />
            <Validator isChecked={isChecked} state={branchIds} rules="required"/>
          </div>


          <div className={agentRequestFieldClass}>
            <AgentRequestFieldLabel htmlFor="agent-about-me">{Dict('about_me')}</AgentRequestFieldLabel>
            <Textarea {...agentRequestInputProps}
                      id="agent-about-me"
                      value={agentRequest.about_me}
                      placeholder={Dict('about_me')}
                      onChange={(e) => {
                        setAgentRequest((prev) => ({
                          ...prev,
                          about_me: e.target.value,
                        }));
                      }}
            />
            <div className="flex flex-row mt-2">
              <Validator isChecked={isChecked} state={agentRequest.about_me} rules="required"/>
            </div>
          </div>
        </div>


        <div className="mt-7 flex flex-col gap-3 border-t border-app-border pt-4 sm:flex-row sm:justify-between">
          <Button className={`w-full sm:w-auto ${agentRequestPrimaryButtonClass}`} onClick={save} disabled={isLastStep}>
            مرحله بعدی
          </Button>
          <Button variant="outlined" className={`w-full sm:w-auto ${agentRequestSecondaryButtonClass}`} onClick={() => {
            handlePrev(1)
          }} disabled={isFirstStep}>
            مرحله قبلی
          </Button>
        </div>
      </>
    </ValidatorProvider>
  )
    ;
}
